import './App.css';
import {BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
import {AppBar, Toolbar, Button} from '@mui/material';
import {useState} from 'react';
import Home from "./pages/Home";
import StatsPage from './pages/StatsPage';

function App() {
  const [tasks, setTasks]=useState([]);
  const total=tasks.length;
  const completed=tasks.filter(task => task.done).length;

  return (
    <Router>
      <AppBar position='static'>
        <Toolbar>
        <Button color="inherit" component={Link} to="/">To-Do List</Button>
        <Button color="inherit" component={Link} to="/stats">Statistika</Button>
        </Toolbar>
      </AppBar>
      <Routes>
      <Route path="/" element={<Home tasks={tasks} setTasks={setTasks} />}></Route>
      <Route path="/stats" element={<StatsPage tasks={tasks}  />}></Route>

      </Routes>
    </Router>
  );
}

export default App;
